import { render } from "./DefaultPriceCardsTable.vue?vue&type=template&id=f6b7feac&scoped=true"
import script from "./DefaultPriceCardsTable.vue?vue&type=script&lang=js"
export * from "./DefaultPriceCardsTable.vue?vue&type=script&lang=js"

import "./DefaultPriceCardsTable.vue?vue&type=style&index=0&id=f6b7feac&lang=scss&scoped=true"
import "./DefaultPriceCardsTable.vue?vue&type=style&index=1&id=f6b7feac&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b7feac"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMarkupTable,QTr,QChip});
